export const colors = {
  // ── Shared ───────────────────────────────────────────────
  canvas: {
    primary: '#FAF7F5',  // admin primary off-white page background
    card: '#FFFFFF',        // card / panel background
    dark: '#000000',        // dark surfaces (scanner overlay, modals)
    'card-dark': '#1A1A1A', // dark card
  },
  accent: {
    DEFAULT: '#E31B23',
    dark: '#B91419',   
    surface: '#FDECE9',   // accent surface (used for icons background)
  },
  text: {
    primary: '#000000',
    inverse: '#FFFFFF',
    secondary: '#666666',
    muted: '#999999',
  },
  border: '#E5E5E5',
  scrim: '#00000080',
  success: '#22C55E',
  warning: '#F59E0B',
  role: {
    staff: {
      bg: '#EFF7FF',
      text: '#1677B8',
    },
    manager: {
      bg: '#F3EEFF',
      text: '#7C5CE6',
    },
  },
  stamp: {
    filled: '#E31B23',
    emptyDark: '#333333',
    emptyLight: '#CCCCCC',
  },

  // ── App-specific overrides ────────────────────────────────
  // Only define here when the value differs from the shared fallback above.
  customer: { canvas: { primary: '#F7F5F3' } },
} as const

export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
} as const

export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 20,
  full: 9999,
} as const

export const screens = {
  xs: 375,
  sm: 390,
  md: 430,
  lg: 768,
  xl: 834,
  '2xl': 1024,
  '3xl': 1280,
} as const
